import { removeHash } from '../../../core/js/utils/routerUtils';

export function *productModalHashLauncherSaga(hash) {
    const hashes = {
        '#write-review': () => {
            $('.dom-product-reviews .js-product-write-review').trigger('click');
        }
    };

    if (hash) {
        const func = hashes[hash];

        if (!func) {
            return;
        }

        func();
        removeHash();
    }
}
